<template>
	<v-dialog v-model="dialogMercadoPago" width="450" :fullscreen="false" persistent>
		<div class="card-mercadopago">
			<div class="pa-2" v-if="loading">
				<v-progress-linear color="primary" indeterminate />
			</div>
			<div>
				<div id="statusScreenBrick_container"></div>
				<div id="paymentBrick_container"></div>
				<div class="ml-5 mr-5 pb-5" v-if="!loading && componenteAtual == 'status'">
					<Botao
						mercadopago
						texto="Escolher outro meio de pagamento"
						v-if="pagamentoStatus == 'rejected'"
						@clicar="escolherOutroPagamento"
						class="mb-2"
					/>
					<Botao texto="Chamar no WhatsApp" @clicar="whatsapp" style="background-color: #25D366" mercadopago class="mb-2">
						<template v-slot:icone>
							<v-icon color="white"> mdi-whatsapp </v-icon>
						</template>
					</Botao>
					<Botao texto="Voltar a loja" transparente @clicar="voltarLoja" mercadopago />
				</div>
				<div class="ml-5 mr-5 botao-mercadopago" v-if="!loading && componenteAtual == 'payment'">
					<Botao texto="Cancelar" transparente @clicar="dialogClose" mercadopago />
				</div>
			</div>
		</div>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import Botao from '../shared/Botao.vue'
import mercadopago from './mercadoPago'
import whatsapp from './whatsapp'
import checkout from './checkout'

export default {
	props: {
		dialog: Boolean,
		empresa: Object,
		totalCompras: Number,
	},
	components: {
		Botao,
	},
	data: function () {
		return {
			loading: true,
			componenteAtual: '',
			pagamentoStatus: '',
		}
	},
	computed: {
		...mapGetters({
			idPedido: 'idPedido',
			catalogo: 'catalogo',
		}),
		dialogMercadoPago: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
		pedidoValido() {
			return (
				this.pagamentoStatus == 'approved' ||
				this.pagamentoStatus == 'in_process' ||
				this.pagamentoStatus == 'pending'
			)
		},
	},
	methods: {
		dialogClose() {
			if (this.componenteAtual == 'payment') this.closePaymentBrick()
			if (this.componenteAtual == 'status') this.closeStatusScreen()
			this.pagamentoStatus = ''
			this.$emit('dialogClose')
		},
		closePaymentBrick() {
			window.paymentBrickController.unmount()
		},
		closeStatusScreen() {
			window.statusScreenBrickController.unmount()
		},
		whatsapp() {
			whatsapp()
		},
		setCarregamento(value) {
			this.loading = value
		},
		setComponenteAtual(value) {
			this.componenteAtual = value
		},
		setPagamentoStatus(value) {
			this.pagamentoStatus = value
		},
		voltarLoja() {
			this.$router.push(`/${this.catalogo.identificadorCatalogo}${this.retornarQueryVendedor()}`)
			window.location.reload()
		},
		escolherOutroPagamento() {
			this.closeStatusScreen()
			this.chamarMercadopago()
		},
		chamarMercadopago() {
			this.loading = true
			mercadopago(
				this.totalCompras.toFixed(2),
				this.empresa.mercadopagoPublicKey,
				this.setCarregamento,
				this.setComponenteAtual,
				this.setPagamentoStatus,
				this.tratarErro
			)
		},
		tratarErro(error) {
			const msg = error == 'PIX'? 'PIX expirado! Tente novamente!': 'Erro ao pagar pelo site, tente novamente ou tente pagar de outra forma!' 
			this.dialogClose()
			this.$store.dispatch('showError', msg)
		},
		salvarPedido() {
			checkout()
		},
	},
	watch: {
		dialog() {
			if (this.dialog) this.chamarMercadopago()
		},
	},
}
</script>

<style scoped>
.scroll {
	overflow-y: scroll;
}

.card-mercadopago {
	border-radius: 12px;
	background-color: white;
}

.botao-mercadopago{
	position: relative;
	top: -2rem;
}
</style>
